const $ = require('cash-dom');
const Page = require('./page');

const StarsRating = {
    init() {
        let scorePercent = function (e, stars_holder) {
            var width = $(stars_holder).width();
            var left = e.pageX - $(stars_holder).offset().left;
            var offset = Math.min(Math.max(0, Page.isRTL() ? width - left : left), width);
            return Math.round((offset / width * 100 / 10) + 0.49) * 10;
        };

        let updateSelectedScore = function (score) {
            const $selectedRatingSpan = $('#selected-rating span');

            if ($selectedRatingSpan.length === 0) {
                return false;
            }

            let scoreClass = 'bad';

            if (score >= 8) {
                scoreClass = 'good';
            } else if (score >= 5) {
                scoreClass = 'neutral';
            }
            $selectedRatingSpan
              .removeClass('bad')
              .removeClass('neutral')
              .removeClass('good')
              .addClass(scoreClass)
              .text(score.toFixed(1));
        };

        $(document)
          .on('mousemove', '.editable-rating', function (e) {
              let percent = scorePercent(e, this);
              $(this).attr("style", "--rating: " + (percent) + '%');

              let score = Math.round(percent * 10 / 100) / 5 * 5;

              updateSelectedScore(score);
          })

          .on('click', '.editable-rating', function (e) {
              e.stopPropagation();

              let $input = $(this).find('input[type="hidden"]');

              let score = Math.round(scorePercent(e, this) * 10 / 100) / 5 * 5;

              if ($input.length > 0) {
                  $input.val(score).trigger('change');
              }

              updateSelectedScore(score);
          })

          .on('mouseleave', '.editable-rating', function () {
              let $input = $(this).find('input[type="hidden"]');
              let score = 0;

              if ($input.length > 0) {
                  score = $input.val();
              }

              $(this).attr("style", "--rating: " + (score * 10) + "%");

              updateSelectedScore(+$input.val());
          });
    },
};

module.exports = StarsRating;
